import React from 'react';
import { EmailPreviewBox } from './PreviewNewsletter.styles';
import PropTypes from 'prop-types';
const PreviewComponent = ({ newsletter }) => {
  return (
    <EmailPreviewBox>
      <h1>{newsletter.newsletterTitle}</h1>
      <p className="month">{newsletter.month}</p>
      <div className="block">
        <h2>{newsletter.title1}</h2>
        <p>{newsletter.content1}</p>
      </div>
      <div className="block">
        <h2>{newsletter.title2}</h2>
        <p>{newsletter.content2}</p>
      </div>
      <div className="block">
        <h2>{newsletter.title3}</h2>
        <p>{newsletter.content3}</p>
      </div>
    </EmailPreviewBox>
  );
};
PreviewComponent.propTypes = {
  newsletter: PropTypes.object,
};

export default PreviewComponent;
